var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-factors" },
    [
      _c(
        "div",
        { staticClass: "main-factors__filters" },
        [
          _c("c-input", {
            staticClass: "main-factors__filters__filial",
            attrs: {
              label: "Филиал",
              type: "select",
              searchable: true,
              clearable: true,
              items: _vm.filialItems,
              placeholder: "Все",
            },
            model: {
              value: _vm.filialLocal,
              callback: function ($$v) {
                _vm.filialLocal = $$v
              },
              expression: "filialLocal",
            },
          }),
          _c("c-input", {
            ref: "mainFactorsPeriod",
            staticClass: "main-factors__filters__period",
            attrs: {
              label: "За период",
              placeholder: "00.00.0000 - 00.00.0000",
              type: "period",
              icon: "calendar",
              clearable: true,
              "icon-right": true,
            },
            model: {
              value: _vm.periodLocal,
              callback: function ($$v) {
                _vm.periodLocal = $$v
              },
              expression: "periodLocal",
            },
          }),
          _c(
            "div",
            { staticClass: "main-factors__filters__buttons" },
            [
              _c("c-button", {
                staticClass: "main-factors__filters__buttons__apply",
                attrs: { label: "Применить", color: "primary" },
                on: { click: _vm.applyFilters },
              }),
              _c("c-button", {
                staticClass: "main-factors__filters__buttons__reset",
                attrs: { label: "Сбросить" },
                on: { click: _vm.resetFilters },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-switcher", {
        staticClass: "main-factors__switcher",
        attrs: {
          type: "group",
          items: [
            { label: "По сменам", value: "shifts" },
            { label: "Суммарные показатели", value: "summary" },
          ],
        },
        model: {
          value: _vm.switcherLocal,
          callback: function ($$v) {
            _vm.switcherLocal = $$v
          },
          expression: "switcherLocal",
        },
      }),
      _c(
        "div",
        {
          staticClass: "main-factors__tabs",
          class: {
            "main-factors__tabs__shifts": _vm.switcherLocal === "shifts",
          },
        },
        [
          _vm.switcherLocal === "shifts" && !_vm.isDataLoading
            ? _c("c-data-table-personal-employee", {
                ref: "table",
                staticClass: "main-factors__tabs__in__shifts__table",
                attrs: {
                  id: "mainFactorsShiftsTable",
                  "empty-records-label": "Записи не найдены",
                  levels: 1,
                  "disabled-columns": [],
                  data: _vm.tableData,
                },
              })
            : _vm._e(),
          _vm.switcherLocal === "summary" && !_vm.isDataLoading
            ? _c(
                "div",
                { staticClass: "main-factors__tabs__summary" },
                _vm._l(_vm.summaryLocalData, function (item) {
                  return _c(
                    "div",
                    {
                      key: `summary-${item.filial_name}`,
                      staticClass: "main-factors__tabs__summary__item",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "main-factors__tabs__summary__item__summ",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "main-factors__tabs__summary__item__summ__title",
                            },
                            [_vm._v(_vm._s(item.filial_name))]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "main-factors__tabs__summary__item__summ__count",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.total === 0
                                      ? 0
                                      : _vm.formatAmount(item.total)
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "main-factors__tabs__summary__item__summ__time",
                            },
                            [
                              _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      trigger: "hover",
                                      content: "Какой-то тултип",
                                      placement: "top",
                                    },
                                    expression:
                                      "{ trigger: 'hover', content: 'Какой-то тултип', placement: 'top' }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass:
                                  "main-factors__tabs__summary__item__summ__time__icon",
                                attrs: { size: "iconic", icon: "time" },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__summ__time__title",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.worked_day) +
                                      " смен, " +
                                      _vm._s(
                                        !Number.isInteger(item.worked_hour)
                                          ? item.worked_hour.toFixed(2)
                                          : item.worked_hour
                                      ) +
                                      " ч 00 мин "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "main-factors__tabs__summary__item__money",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "main-factors__tabs__summary__item__money__main",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__main__count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.paid === 0
                                          ? 0
                                          : _vm.formatAmount(item.paid)
                                      ) +
                                      " " +
                                      _vm._s(_vm.currencyLabel) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__main__title",
                                },
                                [_vm._v("Основная часть")]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "main-factors__tabs__summary__item__money__variable",
                              class: {
                                "main-factors__tabs__summary__item__money__variable__green":
                                  item.bonus > 0,
                                "main-factors__tabs__summary__item__money__variable__grey":
                                  item.bonus === 0,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__variable__count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.bonus === 0
                                          ? 0
                                          : _vm.formatAmount(item.bonus)
                                      ) +
                                      " " +
                                      _vm._s(_vm.currencyLabel) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__variable__title",
                                },
                                [_vm._v("Переменная часть")]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "main-factors__tabs__summary__item__money__depremal main-factors__tabs__summary__item__money__depremal__grey",
                              class: {
                                "main-factors__tabs__summary__item__money__depremal__red":
                                  item.penalty > 0,
                                "main-factors__tabs__summary__item__money__depremal__grey":
                                  item.penalty === 0,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__depremal__count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.penalty === 0
                                          ? 0
                                          : _vm.formatAmount(item.penalty)
                                      ) +
                                      " " +
                                      _vm._s(_vm.currencyLabel) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__depremal__title",
                                },
                                [_vm._v("Депрем-е")]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "main-factors__tabs__summary__item__money__incentives",
                              class: {
                                "main-factors__tabs__summary__item__money__incentives__green":
                                  item.summ_bonus > 0,
                                "main-factors__tabs__summary__item__money__incentives__grey":
                                  item.summ_bonus === 0,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__incentives__count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.summ_bonus === 0
                                          ? 0
                                          : _vm.formatAmount(item.summ_bonus)
                                      ) +
                                      " " +
                                      _vm._s(_vm.currencyLabel) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__incentives__title",
                                },
                                [_vm._v("Поощрения")]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "main-factors__tabs__summary__item__money__fines",
                              class: {
                                "main-factors__tabs__summary__item__money__fines__red":
                                  item.summ_fine > 0,
                                "main-factors__tabs__summary__item__money__fines__grey":
                                  item.summ_fine === 0,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__fines__count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.summ_fine === 0
                                          ? 0
                                          : _vm.formatAmount(item.summ_fine)
                                      ) +
                                      " " +
                                      _vm._s(_vm.currencyLabel) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "main-factors__tabs__summary__item__money__fines__title",
                                },
                                [_vm._v("Штрафы")]
                              ),
                              item.count_fine
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "main-factors__tabs__summary__item__money__fines__amount",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.count_fine) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.isDataLoading
            ? _c("c-loader", {
                staticClass: "main-factors__tabs__loader",
                attrs: {
                  label: "Данные загружаются",
                  active: _vm.isDataLoading,
                  height: "200",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }